import React from 'react'
import {Select} from '@sabre/spark-react'


export default (locals) => {

    const {
        attrs: {className},
        disabled,
        error,
        hasError,
        label,
        onChange,
        options,
        typeInfo: {isMaybe},
        value
    } = locals

    let errorMessage = ''

    if (hasError && error && error.props && error.props.children) {
        errorMessage = error.props.children
    }

    const props = {
        className: className ? className : '',
        defaultValue: value,
        disabled,
        errorMessage,
        label,
        onChange,
        options,
        required: !isMaybe,
        value
    }

    Object.keys(props).forEach(key => {
        if (props[key] === undefined) delete props[key]
    })

    return (
        <Select {...props} />
    )
}


// WEBPACK FOOTER //
// ./src/shared/components/tcomb/sparkSelectLayout.js